<script setup lang="ts">
import { FdxToaster } from '@foodics/ui-common';
import { useAppReady } from '@/composables/appReady';
import { useAppUpdate } from '@/composables/appUpdate';
import AppSplashScreen from '@/components/AppSplashScreen.vue';
import AppUpdateNotification from '@/components/AppUpdateNotification.vue';
import { computed, ref, watch, watchEffect } from 'vue';
import { useRoute } from 'vue-router';
import { useLocale } from './composables/locale';

const { isDataReady } = useAppReady();
const { isUpdateAvailable } = useAppUpdate();

// Once initialized, stay initialized (prevents splash from showing again after OTP)
const hasInitialized = ref(false);
watch(
    isDataReady,
    (ready) => {
        if (ready) hasInitialized.value = true;
    },
    { immediate: true },
);

const isAppInitialized = computed(
    () => hasInitialized.value || isDataReady.value,
);

const route = useRoute();
const { t } = useLocale();

watchEffect(() => {
    if (!isDataReady.value) return;

    const routeTitle = route.meta.title;

    document.title = routeTitle
        ? `${routeTitle} | ${t('generic.common_terms.foodics_bank')}`
        : t('generic.common_terms.foodics_bank');
});
</script>

<template>
    <template v-if="isAppInitialized">
        <FdxToaster />
        <RouterView />
    </template>

    <AppSplashScreen v-else />

    <AppUpdateNotification v-if="isUpdateAvailable" />
</template>
